import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const Dashboard = Loadable({
  loader: () => import("../../container/dashboard"),
  loading() {
    return <Loader />;
  }
});

export const DashboardRoute: IRoute[] = [
  {
    path: "/dashboard",
    element: <Dashboard />
  }
];
